<app-protected-information *ngIf="this.configurationService.application.enablePrivacyAct"></app-protected-information>
<div class="row mt-3">
  <div class="col-12">
    <p class="small text-primary">{{ "onboarding.photos.identification_instructions" | translate: {Default:"Solo 2 pasos para verificar tu identidad"} }}</p>
  </div>
</div>

<form #form="ngForm" (ngSubmit)="form.form.valid && onSubmit()" novalidate >
  <div class="row justify-content-md-center">

    <div class="col-12 col-md-6">

      <div class="wrap-select">
        <div class="row">
          <strong>{{ "onboarding.photos.firstIdentificationLabel" | translate: {Default:"1. Identificación válida"} }}</strong>
        </div>

        <div class="row selects">

          <div>
            <input id="identificationCountry" type="text"
                   name="identificationCountry"
                   class="form-control"
                   placeholder="{{this.translate.instant('onboarding.photos.identificationCountry_select', {Default:  'País'})}}"
                   [(ngModel)]="selectedCountry"
                   [ngbTypeahead]="searchIdentificationCountry"
                   (focus)="onFocus1()"
                   (blur)="onBlur1()"
                   (click)="clickIdentificationCountry$.next($any($event).target.value)"
                   [resultFormatter]="itemToString"
                   [inputFormatter]="itemToString"
                   [editable]="false"
                   (ngModelChange)="assignCountry()"
                   #instanceIdentificationCountry="ngbTypeahead"
                   #identificationCountry="ngModel"
                   not-null
                   [ngClass]="inputFieldCss(identificationCountry, form)"
            />
            <app-field-error-display [control]="identificationCountry" [form]="form"></app-field-error-display>
          </div>

          <div>
            <select
              class="form-control custom-select"
              name="firstId"
              [(ngModel)]="id1"
              #firstId="ngModel"
              [ngClass]="inputFieldCss(firstId, form)"
              (focus)="selectSize1 = 5; this.onSelect = true;"
              (blur)="selectSize1 = 1; this.onSelect = false;"
              (ngModelChange)="onFirstIdChange()"
              required
              [size]="selectSize1">
              <option [ngValue]="undefined" (click)="onOptionSelect('firstId')"></option>
              <option *ngFor="let doc of docCatalog1" [ngValue]="doc" (click)="onOptionSelect('firstId')">{{doc.value}}</option>
            </select>
          </div>

        </div>
      </div>

      <figure class="border-card" *ngIf="!onSelect">
        <span>
          <i class="fa text-info fa-info-circle"></i>
        </span>
        <span>
          {{ "onboarding.photos.firstIdentificationInfo" | translate: {Default:"La identificación debe tener tu foto y nombre legal (Algunos de ellos requieren prueba de la identificación del frente y del reverso)."} }}
        </span>
      </figure>

      <section *ngIf="id1">

        <article>

          <div>
            <img *ngIf="!application.identificationFront && !front1isPDF" height="75" width="110" src="assets/images/onboarding/icons_id.png"/>

            <figure *ngIf="application.identificationFront && !front1isPDF">
              <i *ngIf="this.hasIdFront1"class="fas fa-check-circle text-success top"></i>

              <div class="pdf">
                <i class="far fa-image fa-3x text-info"></i>
              </div>
            </figure>

            <figure *ngIf="front1isPDF">
              <i *ngIf="this.hasIdFront1" class="fas fa-check-circle text-success top"></i>

              <div class="pdf">
                <i class="fas fa-file-pdf fa-3x text-info"></i>
              </div>

            </figure>

            <span>{{ "onboarding.photos.front" | translate }}</span>

          </div>

          <div *ngIf="!application.identificationFront && !front1isPDF; else frontEditButtons">
            <button type="button" class="btn btn-primary" (click)="openModal(modalOptionsUpload); photoType = 'IDENTIFICATION_FRONT' ">
              <i class="fas fa-plus"></i>
            </button>
          </div>
          <ng-template #frontEditButtons>
            <div style="flex-direction: row; gap: 12px;">
              <button type="button" class="btn btn-primary" (click)="openModal(modalOptionsUpload); photoType = 'IDENTIFICATION_FRONT' ">
                <i class="fas fa-pen"></i>
              </button>
              <button type="button" class="btn btn-secondary" (click)="openModal(previewModal); previewId = 'identificationFront' ">
                <i class="far fa-eye"></i>
              </button>
            </div>
          </ng-template>

        </article>

        <article *ngIf="id1?.bothSides">

          <div>
            <img *ngIf="!application.identificationBack  && !back1isPDF" height="75" width="110" src="assets/images/onboarding/icons_id_back.png"/>

            <figure *ngIf="application.identificationBack && !back1isPDF">
              <i *ngIf="this.hasIdBack1"class="fas fa-check-circle text-success top"></i>
              <div class="pdf">
                <i class="far fa-image fa-3x text-info"></i>
              </div>
            </figure>

            <figure *ngIf="back1isPDF">
              <i *ngIf="this.hasIdBack1" class="fas fa-check-circle text-success top"></i>

              <div class="pdf">
                <i class="fas fa-file-pdf fa-3x text-info"></i>
              </div>
            </figure>

            <span>{{ "onboarding.photos.reverse" | translate }}</span>
          </div>

          <div *ngIf="!application.identificationBack && !back1isPDF; else editBackButtons">
            <button type="button" class="btn btn-primary" (click)="openModal(modalOptionsUpload); photoType = 'IDENTIFICATION_BACK' ">
              <i class="fas fa-plus"></i>
            </button>
          </div>
          <ng-template #editBackButtons>
            <div style="flex-direction: row; gap: 12px;">
              <button type="button" class="btn btn-primary" (click)="openModal(modalOptionsUpload); photoType = 'IDENTIFICATION_BACK' ">
                <i class="fas fa-pen"></i>
              </button>
              <button type="button" class="btn btn-secondary" (click)="openModal(previewModal); previewId = 'identificationBack' ">
                <i class="far fa-eye"></i>
              </button>
            </div>
          </ng-template>

        </article>

      </section>

      <!-- <div class="row">
        <label>{{ "onboarding.photos.firstIdentificationLabel" | translate: {Default:"1. Identificación válida"} }}</label>
      </div>

      <div class="card justify-content-center mb-2 p-0" style="border-color: var(--info); border-radius: 15px">
        <div class="row no-gutters">
          <div class="col-2 col-sm-1 d-flex justify-content-center align-items-center p-0 m-0">
            <i class="fa fa-lg text-info fa-info-circle"></i>
          </div>

          <div class="col-10 col-sm-11 d-flex justify-content-center align-items-center p-0 m-0">
            <div class="card-body p-0">
              <p class="card-text responsive-small text-info" style="font-size: 15px">
                {{ "onboarding.photos.firstIdentificationInfo" | translate: {Default:"La identificación debe tener tu foto y nombre legal (Algunos de ellos requieren prueba de la identificación del frente y del reverso)."} }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4">
          <input id="identificationCountry" type="text"
                 name="identificationCountry"
                 class="form-control"
                 placeholder="{{this.translate.instant('onboarding.photos.identificationCountry_select', {Default:  'País'})}}"
                 [(ngModel)]="selectedCountry"
                 [ngbTypeahead]="searchIdentificationCountry"
                 (focus)="onFocus1()"
                 (blur)="onBlur1()"
                 (click)="clickIdentificationCountry$.next($any($event).target.value)"
                 [resultFormatter]="itemToString"
                 [inputFormatter]="itemToString"
                 [editable]="false"
                 (ngModelChange)="assignCountry()"
                 #instanceIdentificationCountry="ngbTypeahead"
                 #identificationCountry="ngModel"
                 not-null
                 [ngClass]="inputFieldCss(identificationCountry, form)"
          />
          <app-field-error-display [control]="identificationCountry" [form]="form"></app-field-error-display>
        </div>
        <div class="col-12 col-md-8">
          <div  class="form-group">
            <select class="form-control custom-select" name="firstId" [(ngModel)]="id1" #firstId="ngModel" [ngClass]="inputFieldCss(firstId, form)" (ngModelChange)="onFirstIdChange()" required>
              <option [ngValue]="undefined">{{ "onboarding.photos.idSelect" | translate: {Default:"Selecciona Identificación"} }}</option>
              <option *ngFor="let doc of docCatalog1" [ngValue]="doc">{{doc.value}}</option>
            </select>
          </div>
        </div>
      </div>

      <ul *ngIf="id1" class="list-unstyled">
        <div class="row justify-content-center">
          <div class="col-12 justify-content-center">
            <div class="text-center">
              <i *ngIf="!this.hasIdFront1" class="fas fa-exclamation-circle"></i>
              <i *ngIf="this.hasIdFront1" class="fas fa-check-circle text-success"></i>&nbsp;
              <span>{{ "onboarding.photos.identification1Front" | translate: {Default:"Frente de tu identificación"} }}</span>
              <br>
            </div>
            <div class="text-center">
              <span class="mb-2 small">{{ "onboarding.photos.idFrontLabel" | translate: {Default:"Carga un archivo o toma una fotografía."} }}</span>
            </div>
            <div class="input-group mb-2 justify-content-center">
              <div class="custom-file col-6">
                <input type="file" [class]="this.lang == 'es' ? 'custom-file-input-spanish' : 'custom-file-input-english'" id="id1FrontFile" name="id1FrontFile" aria-describedby="inputGroupFileAddon01" accept="image/png, image/jpeg, application/pdf" [(ngModel)]="id1FrontFileValue" #id1FrontFile='ngModel' (change)="changeFile($event.target, docTypes.IDENTIFICATION_FRONT)" [ngClass]="inputFieldCss(id1FrontFile, form)">
                <label *ngIf="application.uploadedId1Front" class="custom-file-label" for="id1FrontFile">{{application.identificationFront.name}}</label>
                <label *ngIf="!application.uploadedId1Front" class="custom-file-label" for="id1FrontFile"></label>
              </div>
              <div class="col-6 mt-1 text-center">
                <button class="btn btn-secondary" type="button" (click)="openPhotoModal(modal_takePhoto, docTypes.IDENTIFICATION_FRONT)">
                  <i class="fas fa-camera"></i><span>{{ "onboarding.photos.camera_takePhoto" | translate: {Default:" Tomar Foto"} }}</span>
                </button>
              </div>
            </div>
            <div *ngIf="application.identificationFront != null && !application.uploadedId1Front" class="row justify-content-center">
              <div class="col-5 mb-2">
                <img src="{{application.identificationFront}}" class="img-thumbnail" alt="...">
              </div>
            </div>
            <div *ngIf="application.identificationFront != null && application.uploadedId1Front" class="row justify-content-center mt-1">
              <div class="col-12 text-center">
                <i class="fas fa-4x fa-file-upload"></i>
                <p class="wrap-text small" >{{ "onboarding.photos.fileUploaded" | translate: {Default:"Archivo cargado correctamente: "} }}{{application.identificationFront.name}}</p>
              </div>
            </div>
          </div>
        </div>

        <li *ngIf="id1?.bothSides" class="mb-4">
          <hr>
          <div class="row justify-content-center">
            <div class="col-12 justify-content-center">
              <div class="text-center">
                <i *ngIf="!this.hasIdBack1" class="fas fa-exclamation-circle"></i>
                <i *ngIf="this.hasIdBack1" class="fas fa-check-circle text-success"></i>&nbsp;
                <span>{{ "onboarding.photos.identification1Back" | translate: {Default:"Reverso de tu identificación"} }}</span>
                <br>
              </div>
              <div class="text-center">
                <span class="mb-2 small">{{ "onboarding.photos.idBackLabel" | translate: {Default:"Carga un archivo o toma una fotografía."} }}</span>
              </div>
              <div class="input-group mb-2 justify-content-center">
                <div class="custom-file col-6">
                  <input type="file" [class]="this.lang == 'es' ? 'custom-file-input-spanish' : 'custom-file-input-english'" id="id1BackFile" name="id1BackFile" aria-describedby="inputGroupFileAddon01" accept="image/png, image/jpeg, application/pdf" [(ngModel)]="id1BackFileValue" #id1BackFile='ngModel' (change)="changeFile($event.target, docTypes.IDENTIFICATION_BACK)" [ngClass]="inputFieldCss(id1BackFile, form)">
                  <label *ngIf="application.uploadedId1Back" class="custom-file-label" for="id1BackFile">{{application.identificationBack.name}}</label>
                  <label *ngIf="!application.uploadedId1Back" class="custom-file-label" for="id1BackFile"></label>
                </div>
                <div class="mt-1 col-6 text-center">
                  <button class="btn btn-secondary" type="button" (click)="openPhotoModal(modal_takePhoto, docTypes.IDENTIFICATION_BACK)">
                    <i class="fas fa-camera"></i><span>{{ "onboarding.photos.camera_takePhoto" | translate: {Default:" Tomar Foto"} }}</span>
                  </button>
                </div>
              </div>
              <div *ngIf="application.identificationBack != null && !application.uploadedId1Back" class="row justify-content-center">
                <div class="col-5 mb-2">
                  <img src="{{application.identificationBack}}" class="img-thumbnail" alt="...">
                </div>
              </div>
              <div *ngIf="application.identificationBack != null && application.uploadedId1Back" class="row justify-content-center mt-1">
                <div class="col-12 text-center">
                  <i class="fas fa-4x fa-file-upload"></i>
                  <p class="wrap-text small" >{{ "onboarding.photos.fileUploaded" | translate: {Default:"Archivo cargado correctamente: "} }}{{application.identificationBack.name}}</p>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul> -->

    </div>

    <div class="col-12 col-md-6">

      <div class="wrap-select">
        <div class="row">
          <strong>{{ "onboarding.photos.secondIdentificationLabel" | translate: {Default:"2. Documento o identificación válida"} }}</strong>
        </div>

        <div class="row selects">

          <div>
            <input id="identificationCountry2" type="text"
                    name="identificationCountry2"
                    class="form-control"
                    placeholder="{{this.translate.instant('onboarding.photos.identificationCountry_select', {Default:  'Escribe el país'})}}"
                    [(ngModel)]="selectedCountry2"
                    [ngbTypeahead]="searchIdentificationCountry2"
                    (focus)="onFocus2()"
                    (blur)="onBlur2()"
                    (click)="clickIdentificationCountry2$.next($any($event).target.value)"
                    [resultFormatter]="itemToString"
                    [inputFormatter]="itemToString"
                    [editable]="false"
                    (ngModelChange)="assignCountry2()"
                    #instanceIdentificationCountry2="ngbTypeahead"
                    #identificationCountry2="ngModel"
                    not-null
                    [ngClass]="inputFieldCss(identificationCountry2, form)"
                    [disabled]="this.disableCountry2"
            />
            <app-field-error-display [control]="identificationCountry2" [form]="form"></app-field-error-display>
          </div>

          <div>
            <select class="form-control custom-select"
                    name="secondId"
                    [(ngModel)]="id2"
                    #secondId="ngModel"
                    [ngClass]="inputFieldCss(secondId, form)"
                    (focus)="selectSize2 = 5; this.onSelect2 = true;"
                    (blur)="selectSize2 = 1; this.onSelect2 = false;"
                    (ngModelChange)="onSecondIdChange()"
                    required
                    [size]="selectSize2">
              <option [ngValue]="undefined" (click)="onOptionSelect('secondId')"></option>
              <option *ngFor="let doc of docCatalog2" [ngValue]="doc" (click)="onOptionSelect('secondId')">
                {{doc.value}}
              </option>
            </select>
          </div>

        </div>
      </div>

      <figure class="border-card" *ngIf="!this.onSelect2">
        <span>
          <i class="fa text-info fa-info-circle"></i>
        </span>
        <span>
          {{ "onboarding.photos.secondIdentificationInfo" | translate: {Default:"Si seleccionas una identificación, debe tener foto y nombre legal. Si seleccionas un documento, debe tener dirección y nombre legal."} }}
        </span>
      </figure>

      <section *ngIf="id2">

        <article>

          <div>
            <img *ngIf="!application.identification2Front && !front2isPDF" height="75" width="110" src="assets/images/onboarding/icons_document.png"/>

            <figure *ngIf="application.identification2Front && !front2isPDF">
              <i *ngIf="this.hasIdFront2"class="fas fa-check-circle text-success top"></i>
              <div class="pdf">
                <i class="far fa-image fa-3x text-info"></i>
              </div>
            </figure>

            <figure *ngIf="front2isPDF">
              <i *ngIf="this.hasIdFront2" class="fas fa-check-circle text-success top"></i>

              <div class="pdf">
                <i class="fas fa-file-pdf fa-3x text-info"></i>
              </div>
            </figure>

            <span>{{ "onboarding.photos.front" | translate }}</span>
          </div>

          <div *ngIf="!application.identification2Front && !front2isPDF; else frontEditButtons2">
            <button type="button" class="btn btn-primary" (click)="openModal(modalOptionsUpload); photoType = 'IDENTIFICATION2_FRONT' ">
              <i class="fas fa-plus"></i>
            </button>
          </div>
          <ng-template #frontEditButtons2>
            <div style="flex-direction: row; gap: 12px;">
              <button type="button" class="btn btn-primary" (click)="openModal(modalOptionsUpload); photoType = 'IDENTIFICATION2_FRONT' ">
                <i class="fas fa-pen"></i>
              </button>
              <button type="button" class="btn btn-secondary" (click)="openModal(previewModal); previewId = 'identification2Front' ">
                <i class="far fa-eye"></i>
              </button>
            </div>
          </ng-template>

        </article>

        <article *ngIf="id2?.bothSides">

          <div>
            <img *ngIf="!application.identification2Back && !back2isPDF" height="75" width="110" src="assets/images/onboarding/icons_document.png"/>

            <figure *ngIf="application.identification2Back  && !back2isPDF">
              <i *ngIf="this.hasIdBack2"class="fas fa-check-circle text-success top"></i>
              <div class="pdf">
                <i class="far fa-image fa-3x text-info"></i>
              </div>
            </figure>

            <figure *ngIf="back2isPDF">
              <i *ngIf="this.hasIdBack2" class="fas fa-check-circle text-success top"></i>

              <div class="pdf">
                <i class="fas fa-file-pdf fa-3x text-info"></i>
              </div>
            </figure>

            <span>{{ "onboarding.photos.reverse" | translate }}</span>
          </div>

          <div *ngIf="!application.identification2Back && !back2isPDF; else editBackButtons2">
            <button type="button" class="btn btn-primary" (click)="openModal(modalOptionsUpload); photoType = 'IDENTIFICATION2_BACK' ">
              <i class="fas fa-plus"></i>
            </button>
          </div>
          <ng-template #editBackButtons2>
            <div style="flex-direction: row; gap: 12px;">
              <button type="button" class="btn btn-primary" (click)="openModal(modalOptionsUpload); photoType = 'IDENTIFICATION2_BACK' ">
                <i class="fas fa-pen"></i>
              </button>
              <button type="button" class="btn btn-secondary" (click)="openModal(previewModal); previewId = 'identification2Back' ">
                <i class="far fa-eye"></i>
              </button>
            </div>
          </ng-template>

        </article>

      </section>

      <!-- <div class="row">
        <label>{{ "onboarding.photos.secondIdentificationLabel" | translate: {Default:"2. Documento o identificación válida"} }}</label>
      </div>

      <div class="card justify-content-center mb-2 p-0" style="border-color: var(--info); border-radius: 15px">
        <div class="row no-gutters">
          <div class="col-2 col-sm-1 d-flex justify-content-center align-items-center p-0 m-0">
            <i class="fa fa-lg text-info fa-info-circle"></i>
          </div>

          <div class="col-10 col-sm-11 d-flex justify-content-center align-items-center p-0 m-0">
            <div class="card-body p-0">
              <p class="card-text responsive-small text-info" style="font-size: 15px">
                {{ "onboarding.photos.secondIdentificationInfo" | translate: {Default:"Si seleccionas una identificación, debe tener foto y nombre legal. Si seleccionas un documento, debe tener dirección y nombre legal."} }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4">
          <input id="identificationCountry2" type="text"
                 name="identificationCountry2"
                 class="form-control"
                 placeholder="{{this.translate.instant('onboarding.photos.identificationCountry_select', {Default:  'Escribe el país'})}}"
                 [(ngModel)]="selectedCountry2"
                 [ngbTypeahead]="searchIdentificationCountry2"
                 (focus)="onFocus2()"
                 (blur)="onBlur2()"
                 (click)="clickIdentificationCountry2$.next($any($event).target.value)"
                 [resultFormatter]="itemToString"
                 [inputFormatter]="itemToString"
                 [editable]="false"
                 (ngModelChange)="assignCountry2()"
                 #instanceIdentificationCountry2="ngbTypeahead"
                 #identificationCountry2="ngModel"
                 not-null
                 [ngClass]="inputFieldCss(identificationCountry2, form)"
                 [disabled]="this.disableCountry2"
          />
          <app-field-error-display [control]="identificationCountry2" [form]="form"></app-field-error-display>
        </div>
        <div class="col-12 col-md-8">
          <div class="form-group">
            <select class="form-control custom-select" name="secondId" [(ngModel)]="id2" #secondId="ngModel" [ngClass]="inputFieldCss(secondId, form)" (ngModelChange)="onSecondIdChange()" required>
              <option [ngValue]="undefined">{{ "onboarding.photos.docSelect" | translate: {Default:"Selecciona Documento o Identificación"} }}</option>
              <option *ngFor="let doc of docCatalog2" [ngValue]="doc">{{doc.value}}</option>
            </select>
          </div>
        </div>
      </div>

      <ul *ngIf="id2" class="list-unstyled">
        <div class="row justify-content-center">
          <div class="col-12 justify-content-center">
            <div class="text-center">
              <i *ngIf="!this.hasIdFront2" class="fas fa-exclamation-circle"></i>
              <i *ngIf="this.hasIdFront2" class="fas fa-check-circle text-success"></i>&nbsp;
              <span *ngIf="id2.type == 'IDENTIFICATION'">{{ "onboarding.photos.identification2Front" | translate: {Default:"Frente de la identificación"} }}</span>
              <span *ngIf="id2.type != 'IDENTIFICATION'">{{ "onboarding.photos.Document2Front" | translate: {Default:"Documento"} }}</span>
              <br>
            </div>
            <div class="text-center">
              <span class="mb-2 small">{{ "onboarding.photos.idFrontLabel" | translate: {Default:"Carga un archivo o toma una fotografía."} }}</span>
            </div>
            <div class="input-group mb-2 justify-content-center">
              <div class="custom-file col-6">
                <input type="file" [class]="this.lang == 'es' ? 'custom-file-input-spanish' : 'custom-file-input-english'" id="id2FrontFile" name="id2FrontFile" aria-describedby="inputGroupFileAddon01" accept="image/png, image/jpeg, application/pdf" [(ngModel)]="id2FrontFileValue" #id2FrontFile='ngModel' (change)="changeFile($event.target,docTypes.IDENTIFICATION2_FRONT)" [ngClass]="inputFieldCss(id2FrontFile, form)">
                <label *ngIf="application.uploadedId2Front" class="custom-file-label" for="id2FrontFile">{{application.identification2Front.name}}</label>
                <label *ngIf="!application.uploadedId2Front" class="custom-file-label" for="id2FrontFile"></label>
              </div>
              <div class="mt-1 col-6 text-center">
                <button class="btn btn-secondary" type="button" (click)="openPhotoModal(modal_takePhoto, docTypes.IDENTIFICATION2_FRONT)">
                  <i class="fas fa-camera"></i><span>{{ "onboarding.photos.camera_takePhoto" | translate: {Default:" Tomar Foto"} }}</span>
                </button>
              </div>
            </div>
            <div *ngIf="application.identification2Front != null && !application.uploadedId2Front" class="row justify-content-center">
              <div class="col-5 mb-2">
                <img src="{{application.identification2Front}}" class="img-thumbnail" alt="...">
              </div>
            </div>
            <div *ngIf="application.identification2Front != null && application.uploadedId2Front" class="row justify-content-center mt-1">
              <div class="col-12 text-center">
                <i class="fas fa-4x fa-file-upload"></i>
                <p class="wrap-text small" >{{ "onboarding.photos.fileUploaded" | translate: {Default:"Archivo cargado correctamente: "} }}{{application.identification2Front.name}}</p>
              </div>
            </div>

          </div>
        </div>

        <li *ngIf="id2?.bothSides" class="mb-4">
          <hr>
          <div class="row justify-content-center">
            <div class="col-12 justify-content-center">
              <div class="text-center">
                <i *ngIf="!this.hasIdBack2" class="fas fa-exclamation-circle"></i>
                <i *ngIf="this.hasIdBack2" class="fas fa-check-circle text-success"></i>&nbsp;
                <span *ngIf="id2.type == 'IDENTIFICATION' && id2.id != 'SPECIAL_DOCUMENT_WITH_LETTER'">{{ "onboarding.photos.identification2Back" | translate: {Default:"Reverso de la identificación"} }}</span>
                <span *ngIf="id2.type != 'IDENTIFICATION' && id2.id != 'SPECIAL_DOCUMENT_WITH_LETTER'">{{ "onboarding.photos.Document2Back" | translate: {Default:"Reverso del documento"} }}</span>
                <span *ngIf="id2.id == 'SPECIAL_DOCUMENT_WITH_LETTER'">{{ "onboarding.photos.Document2Letter" | translate: {Default:"Carta"} }}</span>
                <br>
              </div>
              <div class="text-center">
                <span class="mb-2 small">{{ "onboarding.photos.idBackLabel" | translate: {Default:"Carga un archivo o toma una fotografía."} }}</span>
              </div>
              <div class="input-group mb-2 justify-content-center">
                <div class="custom-file col-6">
                  <input type="file" [class]="this.lang == 'es' ? 'custom-file-input-spanish' : 'custom-file-input-english'" id="id2BackFile" name="id2BackFile" aria-describedby="inputGroupFileAddon01" accept="image/png, image/jpeg, application/pdf" [(ngModel)]="id2BackFileValue" #id2BackFile='ngModel' (change)="changeFile($event.target,docTypes.IDENTIFICATION2_BACK)" [ngClass]="inputFieldCss(id2BackFile, form)">
                  <label *ngIf="application.uploadedId2Back" class="custom-file-label" for="id2BackFile">{{application.identification2Back.name}}</label>
                  <label *ngIf="!application.uploadedId2Back" class="custom-file-label" for="id2BackFile"></label>
                </div>
                <div class="mt-1 col-6 text-center">
                  <button class="btn btn-secondary" type="button" (click)="openPhotoModal(modal_takePhoto, docTypes.IDENTIFICATION2_BACK)">
                    <i class="fas fa-camera"></i><span>{{ "onboarding.photos.camera_takePhoto" | translate: {Default:" Tomar Foto"} }}</span>
                  </button>
                </div>
              </div>
              <div *ngIf="application.identification2Back != null && !application.uploadedId2Back" class="row justify-content-center">
                <div class="col-5 mb-2">
                  <img src="{{application.identification2Back}}" class="img-thumbnail" alt="...">
                </div>
              </div>
              <div *ngIf="application.identification2Back != null && application.uploadedId2Back" class="row justify-content-center mt-1">
                <div class="col-12 text-center">
                  <i class="fas fa-4x fa-file-upload"></i>
                  <p class="wrap-text small" >{{ "onboarding.photos.fileUploaded" | translate: {Default:"Archivo cargado correctamente: "} }}{{application.identification2Back.name}}</p>
                </div>
              </div>
            </div>
          </div>

        </li>
      </ul> -->

    </div>

  </div>

  <div class="col-12 mt-5">
    <button *ngIf="this.appStatus != eApplicationStatusType.BLACK_LIST_DOCUMENTS" class="btn btn-secondary" type="button" (click)="onBack()">{{ "onboarding.personal-data.back" | translate: {Default:"Regresar"} }}</button>
    <button class="btn btn-primary float-right" [disabled]="invalidPhotos() || form.invalid || !cameraPerms">{{ "onboarding.photos.continue" | translate: {Default:"Continuar"} }}</button>
  </div>
</form>

<ng-template #modal_takePhoto let-modal>
  <div class="modal-body justify-content-center">
    <div class="wrapper" (window:resize)="onResize($event)">
      <webcam [imageQuality]="0.7" [trigger]="triggerObservable" [width]="innerWidth" (imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable" (cameraSwitched)="cameraWasSwitched($event)" (initError)="handleInitError($event)"></webcam>
    </div>
  </div>
  <div class="modal-footer text-center">
    <div class="btn-group">
      <button type="button" class="btn btn-outline-danger" (click)="modal.close()"><i class="fas fa-3x fa-times"></i></button>
      <button type="button" class="btn btn-outline-success" (click)="triggerSnapshot(modal)"><i class="fas fa-3x fa-camera"></i></button>
    </div>
  </div>
</ng-template>

<ng-template #modal_instantApproval let-c="close" let-d="dismiss">
  <div class="modal-header">
    <i class="fas fa-2x text-primary fa-info-circle"></i>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p >{{ "onboarding.photos.instantApproval1" | translate: {Default:"Si tienes"} }}
      <b>{{ "onboarding.photos.instantApproval4" | translate: {Default:"Número de Seguridad Social "} }}</b>
    {{ "onboarding.photos.instantApproval5" | translate: {Default:"da click en "} }}
      <b>{{ "onboarding.photos.instantApproval6" | translate: {Default:"Regresa e intenta "} }}</b>
    {{ "onboarding.photos.instantApproval7" | translate: {Default:"y prueba la "} }}
      <b>{{ "onboarding.photos.instantApproval8" | translate: {Default:"aprobación instantánea"} }}</b>
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="c('close')">{{ "onboarding.photos.noThanks" | translate: {Default:"No, gracias"} }}</button>
    <button type="button" class="btn btn-success" (click)="onBackUsaIDs();d()" >{{ "onboarding.photos.backAndTry" | translate: {Default:"Regresa e intenta"} }}</button>
  </div>
</ng-template>

<ng-template #modalOptionsUpload let-c="close" let-d="dismiss">
  <div class="wrap-modal-opts">

    <div>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="title">

      <i class="fa fa-lg text-info fa-info-circle"></i>
      <article>
        <span>
          <!-- Tipo de archivos permitidos: -->
          <span>{{ "onboarding.photos.typeFilesAllowed" | translate }}:</span>
        </span>
        <strong>
          .jpg, .jpeg, .png, .pdf
        </strong>
      </article>

    </div>

    <button type="button" class="btn btn-primary" (click)="d('Cross click'); openPhotoModal(modal_takePhoto)">
      <span>
        <i class="fas fa-camera fa-2x"></i>
      </span>
      <span>{{ "onboarding.photos.takePhoto" | translate }}</span>
    </button>

    <div [ngSwitch]="photoType">

      <div *ngSwitchCase="'IDENTIFICATION_FRONT'">

        <button type="button" class="btn btn-outline-primary custom" onclick="document.getElementById('id1FrontFile').click()">
          <span>
            <i class="fas fa-file-upload fa-2x"></i>
          </span>
          <span>{{ "onboarding.photos.selectFile" | translate }}</span>
        </button>

        <input type="file" id="id1FrontFile" name="id1FrontFile" aria-describedby="inputGroupFileAddon01"
          accept="image/png, image/jpeg, application/pdf" [(ngModel)]="id1FrontFileValue" #id1FrontFile='ngModel'
          (change)="changeFile($event.target, docTypes.IDENTIFICATION_FRONT, d)" [ngClass]="inputFieldCss(id1FrontFile, form)"
          style="display: none;">
      </div>

      <div *ngSwitchCase="'IDENTIFICATION_BACK'">
        <button type="button" class="btn btn-outline-primary custom" onclick="document.getElementById('id1BackFile').click()">
          <span>
            <i class="fas fa-file-upload fa-2x"></i>
          </span>
          <span>{{ "onboarding.photos.selectFile" | translate }}</span>
        </button>

        <input type="file" id="id1BackFile" name="id1BackFile" aria-describedby="inputGroupFileAddon01"
          accept="image/png, image/jpeg, application/pdf" [(ngModel)]="id1BackFileValue" #id1BackFile='ngModel'
          (change)="changeFile($event.target, docTypes.IDENTIFICATION_BACK, d)" [ngClass]="inputFieldCss(id1BackFile, form)"
          style="display: none;">
      </div>

      <div *ngSwitchCase="'IDENTIFICATION2_FRONT'">
        <button type="button" class="btn btn-outline-primary custom" onclick="document.getElementById('id2FrontFile').click()">
          <span>
            <i class="fas fa-file-upload fa-2x"></i>
          </span>
          <span>{{ "onboarding.photos.selectFile" | translate }}</span>
        </button>

        <input type="file" id="id2FrontFile" name="id2FrontFile" aria-describedby="inputGroupFileAddon01"
          accept="image/png, image/jpeg, application/pdf" [(ngModel)]="id2FrontFileValue" #id2FrontFile='ngModel'
          (change)="changeFile($event.target,docTypes.IDENTIFICATION2_FRONT, d)" [ngClass]="inputFieldCss(id2FrontFile, form)"
          style="display: none;">
      </div>

      <div *ngSwitchCase="'IDENTIFICATION2_BACK'">
        <button type="button" class="btn btn-outline-primary custom" onclick="document.getElementById('id2BackFile').click()">
          <span>
            <i class="fas fa-file-upload fa-2x"></i>
          </span>
          <span>{{ "onboarding.photos.selectFile" | translate }}</span>
        </button>

        <input type="file" id="id2BackFile" name="id2BackFile" aria-describedby="inputGroupFileAddon01"
          accept="image/png, image/jpeg, application/pdf" [(ngModel)]="id2BackFileValue" #id2BackFile='ngModel'
          (change)="changeFile($event.target, docTypes.IDENTIFICATION2_BACK, d)" [ngClass]="inputFieldCss(id2BackFile, form)"
          style="display: none;">
      </div>

    </div>

  </div>
</ng-template>

<ng-template #previewModal let-c="close" let-d="dismiss">
  <button type="button" class="close" aria-label="Close" (click)="d('Cross click')" style="padding: 6px 12px;">
    <span aria-hidden="true">&times;</span>
  </button>

  <div class="modal-content" *ngIf="application.identificationFront && previewId == 'identificationFront'">
    <ng-container *ngIf="!front1isPDF; else pdfPreviewFront1">
      <img *ngIf="!application.uploadedId1Front" src="{{application.identificationFront}}">
      <img *ngIf="application.uploadedId1Front" [src]="pdfUrl(application.identificationFront)">
    </ng-container>
  </div>
  <ng-template #pdfPreviewFront1>
    <object [data]="pdfUrl(application.identificationFront)" type="application/pdf" width="100%" height="500px">
      <p>Tu navegador no puede mostrar este PDF. <a [href]="pdfUrl(application.identificationFront)" target="_blank">Descargar</a></p>
    </object>
  </ng-template>

  <div class="modal-content" *ngIf="application.identificationBack && previewId == 'identificationBack'">
    <ng-container *ngIf="!back1isPDF; else pdfPreviewBack1">
      <img *ngIf="!application.uploadedId1Back" src="{{application.identificationBack}}">
      <img *ngIf="application.uploadedId1Back" [src]="pdfUrl(application.identificationBack)">
    </ng-container>
  </div>
  <ng-template #pdfPreviewBack1>
    <object [data]="pdfUrl(application.identificationBack)" type="application/pdf" width="100%" height="500px">
      <p>Tu navegador no puede mostrar este PDF. <a [href]="pdfUrl(application.identificationBack)" target="_blank">Descargar</a></p>
    </object>
  </ng-template>

  <div class="modal-content" *ngIf="application.identification2Front && previewId == 'identification2Front'">
    <ng-container *ngIf="!front2isPDF; else pdfPreviewFront2">
      <img *ngIf="!application.uploadedId2Front" src="{{application.identification2Front}}">
      <img *ngIf="application.uploadedId2Front" [src]="pdfUrl(application.identification2Front)">
    </ng-container>
  </div>
  <ng-template #pdfPreviewFront2>
    <object [data]="pdfUrl(application.identification2Front)" type="application/pdf" width="100%" height="500px">
      <p>Tu navegador no puede mostrar este PDF. <a [href]="pdfUrl(application.identification2Front)" target="_blank">Descargar</a></p>
    </object>
  </ng-template>

  <div class="modal-content" *ngIf="application.identification2Back && previewId == 'identification2Back'">
    <ng-container *ngIf="!back2isPDF; else pdfPreviewBack2">
      <img *ngIf="!application.uploadedId2Back" src="{{application.identification2Back}}">
      <img *ngIf="application.uploadedId2Back" [src]="pdfUrl(application.identification2Back)">
    </ng-container>
  </div>
  <ng-template #pdfPreviewBack2>
    <object [data]="pdfUrl(application.identification2Back)" type="application/pdf" width="100%" height="500px">
      <p>Tu navegador no puede mostrar este PDF. <a [href]="pdfUrl(application.identification2Back)" target="_blank">Descargar</a></p>
    </object>
  </ng-template>

</ng-template>
